import { apiFetch } from './apiClient';

/* Integração com o Docs (gestão de documentos).
   A chave de integração só trafega daqui pro NOSSO backend, na hora de
   salvar -- quem fala com o Docs é o backend, que guarda a chave cifrada.
   Nada nesta camada lê ou exibe a chave depois de salva. */



/* { configurada, base_url, origem, ultimo_teste_em, ultimo_teste_ok } -- nunca a chave */
export async function buscarConfigDocs() {
  return apiFetch('/integracao-docs/config');
}

export async function salvarConfigDocs(dados) {
  return apiFetch('/integracao-docs/config', { method: 'PUT', body: JSON.stringify(dados) });
}

export async function removerConfigDocs() {
  return apiFetch('/integracao-docs/config', { method: 'DELETE' });
}

export async function testarConexaoDocs() {
  return apiFetch('/integracao-docs/testar', { method: 'POST' });
}

/* não escreve nada dos dois lados -- pode rodar quantas vezes quiser */
export async function compararComDocs() {
  return apiFetch('/integracao-docs/comparar', { method: 'POST' });
}

/* só é chamado depois de alguém marcar e clicar em "Vincular selecionados" */
export async function vincularNoDocs(pares) {
  return apiFetch('/integracao-docs/vincular', { method: 'POST', body: JSON.stringify({ pares }) });
}

/* os pares já ligados, sob demanda -- eles não aparecem na fila de
   trabalho, então sem esta lista um vínculo errado fica invisível */
export async function listarLigados() {
  return apiFetch('/integracao-docs/ligados');
}

/* desfaz o vínculo: apaga só a ligação, nenhum cadastro dos dois lados */
export async function desvincularNoDocs(docsIds) {
  return apiFetch('/integracao-docs/desvincular', { method: 'POST', body: JSON.stringify({ docs_ids: docsIds }) });
}

/* cria no Docs os clientes escolhidos daqui -- só para o atrasado: no dia
   a dia isso acontece sozinho ao salvar o cliente */
export async function criarNoDocs(clienteIds) {
  return apiFetch('/integracao-docs/criar-no-docs', { method: 'POST', body: JSON.stringify({ cliente_ids: clienteIds }) });
}

/* clientes que nasceram no Docs e ainda não existem aqui (só leitura) */
export async function listarFaltandoAqui() {
  return apiFetch('/integracao-docs/faltando-aqui');
}

/* cadastra aqui os escolhidos e já fecha o par -- nunca sobrescreve
   cliente que já é nosso, e só age sobre os ids marcados na tela */
export async function criarAquiDoDocs(docsIds) {
  return apiFetch('/integracao-docs/criar-aqui', { method: 'POST', body: JSON.stringify({ docs_ids: docsIds }) });
}
